import * as React from "react";
import { CardFooter } from "../../../card/card-footer/card-footer.mjs";
const OptionCardFooter = (props) => {
  const { background = "transparent", ...rest } = props;
  return /* @__PURE__ */ React.createElement(CardFooter, { ...rest, className: "option-card__footer", background });
};
export {
  OptionCardFooter
};
